import type { Command, CommandTag } from '../types';

import { COMMAND_GROUPS } from '../types';

import { isPrV2Route } from '@/lib/pr-v2/route-utils';

/**
 * The order "This pull request" lists its commands in, most used first. More than one module
 * registers into the group, so the order lives here rather than in registration order.
 */
const PR_COMMAND_ORDER = [
  'pr-v2-review',
  'pr-v2-merge',
  'pr-v2-go-to-file',
  'pr-v2-next-unviewed-file',
  'pr-v2-go-to-finding',
  'pr-v2-next-unresolved-thread',
  'pr-v2-fix-all',
  'pr-v2-add-reviewer',
  'pr-v2-compare',
  'pr-v2-toggle-file-viewed',
  'pr-v2-toggle-draft',
  'pr-v2-toggle-state',
  'pr-v2-copy-link',
  'pr-v2-copy-branch-name',
  'pr-v2-open-github',
  'pr-v2-copy-number',
  'pr-v2-copy-branch-hash',
  'pr-v2-copy-title-as-link',
  'pr-v2-open-preview',
  'pr-v2-run-ai-review',
  'pr-v2-diff-view',
  'pr-v2-collapse-all-files',
  'pr-v2-expand-all-files',
  'pr-v2-refresh-cache',
  'pr-v2-zen-mode',
  'pr-v2-switch-to-discussion',
  'pr-v2-switch-to-changes',
] as const;

export type PrV2CommandId = (typeof PR_COMMAND_ORDER)[number];

// Above every global command's priority, so a command about the open pull request wins a tie.
const PR_COMMAND_PRIORITY_BASE = 6000;

/** A command in the "This pull request" group, placed by its position in the order above. */
export function prV2Command(
  id: PrV2CommandId,
  command: Omit<Command, 'id' | 'group' | 'priority' | 'showOn'>,
): Command {
  return {
    ...command,
    id,
    showOn: isPrV2Route,
    group: COMMAND_GROUPS.PR_COMMANDS.name,
    priority: PR_COMMAND_PRIORITY_BASE - PR_COMMAND_ORDER.indexOf(id),
  };
}

/** A row of a pull request mode, which the palette lists only on pull request pages. */
export function prV2ModeRow(command: Omit<Command, 'showOn'> & { tag: CommandTag }): Command {
  return { ...command, showOn: isPrV2Route };
}
